/**
 * @generated SignedSource<<6985c07e30668bf0a3137d89e31c7ce8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable_rules">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider_rules";
};
export type NativeIssueTableWithSelectedIssuesProvider_rules$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueTable_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "bee4ee6b4e3b0de62d9a8d49cc6ce0f7";

export default node;
